// eslint-disable-next-line import/extensions
import '@/main.js'

import { Buffer } from 'buffer'

globalThis.hasField = (v, k) => Object.hasOwn(v, k) && v[k] !== undefined

globalThis.Buffer = Buffer
